import React from 'react'
import { observer } from 'mobx-react'
import SectionTitle from 'components/UI/SectionTitle/SectionTitle'

import Flex from 'components/UI/Flex/Flex'
import styles from './SlotSettings.module.scss'
import DatePicker from 'react-datepicker'
import { getAdaptedTime } from 'components/Modules/Slots/utils'
import slotsScheduleSettingsStore from 'Stores/slotsScheduleSettingsStore'
import { timeConverter } from '../../../../../ContentBox/Online-schedule/components/functions'
import { addZero } from '../../../../../../helpers/math'
import FormLabel from '../../../../../UI/AsideModal/Form/FormLabel'
import FormField from '../../../../../UI/AsideModal/Form/FormField'

function Time() {
  const { startTime, endTime, setTime } = slotsScheduleSettingsStore

  const handleStartTimeChange = (date) => {
    const formattedTime =
      timeConverter(date, 'time') + `:${addZero(date.getSeconds())}`
    setTime(formattedTime, 'startTime')
  }

  const handleEndTimeChange = (date) => {
    const formattedTime =
      timeConverter(date, 'time') + `:${addZero(date.getSeconds())}`
    setTime(formattedTime, 'endTime')
  }

  return (
    <FormField>
      <FormLabel>Время работы:</FormLabel>
      <div className={styles.datetime_box}>
        <DatePicker
          selected={
            startTime && new Date('2020-01-01 ' + getAdaptedTime(startTime))
          }
          onChange={handleStartTimeChange}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeFormat='HH:mm'
          dateFormat='HH:mm'
          placeholderText='Выберите время'
          className={styles.time_selector}
        />
        <div className={styles.datetimeBoxMiddle}>-</div>
        <DatePicker
          selected={
            endTime && new Date('2020-01-01 ' + getAdaptedTime(endTime))
          }
          onChange={handleEndTimeChange}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeFormat='HH:mm'
          dateFormat='HH:mm'
          placeholderText='Выберите время'
          className={styles.time_selector}
        />
      </div>
    </FormField>
  )
}

export default observer(Time)
